import { TFunction } from 'i18next';

export const getFaqData = (t: TFunction) => ({
	pm: [
		{
			id: 1,
			question: t('question1'),
			answer: `<p>${t('answer1_text1')}</p>
      <p>${t('answer1_text2')}</p>
      <p>${t('answer1_text3')}</p>
      <p>${t('answer1_text4')}</p>
      <p>${t('answer1_text5')}</p>
      `,
			anchor: 'question1'
		},
		{
			id: 2,
			question: t('question2'),
			answer: t('answer2'),
			anchor: 'question2'
		},
		{
			id: 3,
			question: t('question6'),
			answer: `<p>${t('answer6_text1')}</p>
      <p>${t('answer6_text2')}</p>
      <ul>
	      <li>
	        ${t('answer6_text3')}
	      </li>
	      <li>
	        ${t('answer6_text4')}
	      </li>
	      <li>
	        ${t('answer6_text5')}
	      </li>
	      <li>
	        ${t('answer6_text6')}
	      </li>
	      <li>
	        ${t('answer6_text7')}
	      </li>
      </ul>
      `,
			anchor: 'question3'
		},
		{
			id: 4,
			question: t('question3'),
			answer: `<p>${t('answer3_text1')}</p>
      ${t('answer3_text2')}
      `,
			anchor: 'question4'
		},
		{
			id: 5,
			question: t('question4'),
			answer: `<p>${t('answer4_text1')}</p>
			<ul>
	      <li>
	        ${t('answer4_text2')}
	      </li>
	      <li>
	        ${t('answer4_text3')}
	      </li>
	      <li>
	        ${t('answer4_text4')}
	      </li>
	      <li>
	        ${t('answer4_text5')}
	      </li>
      </ul>
      `,
			anchor: 'question5'
		},
		{
			id: 6,
			question: t('question5'),
			answer: t('answer5'),
			anchor: 'question6'
		},
		{
			id: 7,
			question: t('question7'),
			answer: `<p>${t('answer7_text1')}</p>
				<ul>
	        <li>
	          ${t('answer7_text2')}
	        </li>
	        <li>
	          ${t('answer7_text3')}
	        </li>
	        <li>
	          ${t('answer7_text4')}
	        </li>
	        <li>
	          ${t('answer7_text5')}
	        </li>
	        <li>
	          ${t('answer7_text6')}<a target="_blank" href="https://help.steampowered.com/ru/faqs/view/451E-96B3-D194-50FC">${t('go')}</a>
	        </li>
        </ul>
        <p>${t('answer7_text7')}</p>
      `,
			anchor: 'question7'
		},
		{
			id: 8,
			question: t('question8'),
			answer: `<p>${t('answer8_text1')}</p>
        <li>
          ${t('answer8_text2')}
        </li>
        <li>
          ${t('answer8_text3')}
        </li>
        <li>
          ${t('answer8_text4')}<a target="_blank" href="https://help.steampowered.com/ru/faqs/view/7EFD-3CAE-64D3-1C31">${t('go')}</a>
        </li>
        <p>${t('answer8_text5')}</p>
      `,
			anchor: 'question8'
		},
		{
			id: 9,
			question: t('help'),
			answer: `<p>${t('answer7')}</p>
      <Styled.Help>
        <Styled.Tg href='https://t.me/PMKzSupport_bot' target='_blank'>
        </Styled.Tg>
        <Styled.Phone href='tel:9933' target='_blank'>
          9933
        </Styled.Phone>
      </Styled.Tg>
      `,
			anchor: 'question9'
		}
	],
	rockets: [
		{
			id: 1,
			question: t('rockets_faq:question1'),
			answer: `<p>${t('rockets_faq:answer1_text1')}</p>
			<ul>
	      <li>
	        ${t('rockets_faq:answer1_text2')}
	      </li>
	      <li>
	        ${t('rockets_faq:answer1_text3')}
	      </li>
	      <li>
	        ${t('rockets_faq:answer1_text4')}
	      </li>
	      <li>
	        ${t('rockets_faq:answer1_text5')}
	      </li>
	      <li>
	        ${t('rockets_faq:answer1_text6')}
	      </li>
      </ul>
      `,
			anchor: 'question1'
		},
		{
			id: 2,
			question: t('rockets_faq:question2'),
			answer: `<p>${t('rockets_faq:answer2_text1')}</p>
      `,
			anchor: 'question1'
		}
	],
	viphouse: [
		{
			id: 1,
			question: t('question1'),
			answer: `<div>${t('answer1_text1')}</div>
      <div>${t('answer1_text2')}</div>
      
      `,
			anchor: 'question1'
		},
		{
			id: 2,
			question: t('question2'),
			answer: t('answer2'),
			anchor: 'question2'
		},
		{
			id: 3,
			question: t('Як відкрити інвентар у Steam для отримання предметів?'),
			answer: `<div>${t('answer6_text1')}</div>
      <div>${t('answer6_text2')}</div>
      <li>
        ${t('answer6_text3')}
      </li>
      <li>
        ${t('answer6_text4')}
      </li>
      <li>
        ${t('answer6_text5')}
      </li>
      <li>
        ${t('answer6_text6')}
      </li>
      <li>
        ${t('answer6_text7')}
      </li>
      `,
			anchor: 'question3'
		},
		{
			id: 4,
			question: t('question3'),
			answer: `<div>${t('answer3_text1')}</div>
      
      `,
			anchor: 'question4'
		},
		{
			id: 5,
			question: t('question4'),
			answer: `<div>${t('answer4_text1')}</div>
     `,
			anchor: 'question5'
		},
		{
			id: 6,
			question: t('question5'),
			answer: t('answer5'),
			anchor: 'question6'
		},
		{
			id: 7,
			question: 'Чому я не можу зробити покупку в магазині?',
			answer: `<div>Це може бути пов'язано з однією з наступних причин:</div>
        <li>
          Немає трейд посилання в профілі: Переконайся, що у тебе вказано актуальне трейд посилання.

        </li>
        <li>
          Закрито інвентар у Steam: відкрий інвентар у налаштуваннях приватності Steam.

        </li>
        <li>
          Перевищив ліміт покупок на добу: зачекай і спробуй знову пізніше.

        </li>
        <li>
          Недостатньо ХP балів на балансі: перевір, чи вистачає у тебе балів для покупки.

        </li>
        <li>
          Перевір, чи не накладено на твій акаунт трейд-бан у Steam. -> <a target="_blank" href="https://help.steampowered.com/ru/faqs/view/451E-96B3-D194-50FC">Перейти</a>
        </li>
        <p>Якщо всі перераховані вище пункти перевірені, але проблема зберігається, будь ласка, зв'яжись з нашою службою підтримки.
				</p>
      `,
			anchor: 'question7'
		},
		{
			id: 8,
			question: 'Проблема з трейд посиланням',
			answer: `<div>Це може бути пов'язано з однією з наступних причин:</div>
        <li>
          Немає трейд-посилання в профілі.

        </div>
        <li>
          Трейд-посилання в ХPass не збігається з трейд-посиланням у Steam
        </div>
        <li>
          Стався трейд-лок через видалення/додавання аутентифікатора Steam. Дізнатися чому  -> <a target="_blank" href="https://help.steampowered.com/ru/faqs/view/7EFD-3CAE-64D3-1C31">Перейти</a>
        </div>
        <p>Якщо всі перераховані вище пункти перевірені, але проблема зберігається, будь ласка, зв'яжись з нашою службою підтримки.
				</p>
      `,
			anchor: 'question8'
		},
		{
			id: 9,
			question: t('main:help'),
			answer: `<div>${t('answer7')} -> <a target="_blank" href="https://7johnny24.com/uk/support">Перейти</a></div>
      <div>
        
			<a href='mailto:support@johnny24.bet' target='_blank'>
				<PhoneIcon />
				support@johnny24.bet
			</a>

      </div>
      `,
			anchor: 'question9'
		}
	],
	ngu3: [
		{
			id: 1,
			question: t('faq_johnny:question1'),
			answer: `<div>${t('faq_johnny:answer1_text1')}</div>`,
			anchor: 'question1'
		},
		{
			id: 2,
			question: t('faq_johnny:question2'),
			answer: `<div>${t('faq_johnny:answer2')}</div>`,
			anchor: 'question2'
		},
		{
			id: 3,
			question: t('faq_johnny:question3'),
			answer: `<div>${t('faq_johnny:answer3_text1')}</div>
      <div>${t('faq_johnny:answer3_text2')}</div>
      <ul>
      <li>${t('faq_johnny:answer3_text3')}</li>
      <li>${t('faq_johnny:answer3_text4')}</li>
      <li>${t('faq_johnny:answer3_text5')}</li>
      <li>${t('faq_johnny:answer3_text8')}</li>
      <li>${t('faq_johnny:answer3_text9')}</li>
      </ul>`,
			anchor: 'question3'
		},
		{
			id: 4,
			question: t('faq_johnny:question4'),
			answer: `<div>${t('faq_johnny:answer4_text1')}</div>`,
			anchor: 'question4'
		},
		{
			id: 5,
			question: t('faq_johnny:question5'),
			answer: `<div>${t('faq_johnny:answer5')}</div>`,
			anchor: 'question5'
		},
		{
			id: 6,
			question: t('faq_johnny:question6'),
			answer: `<div>${t('faq_johnny:answer6_text1')}</div>`,
			anchor: 'question6'
		},
		{
			id: 7,
			question: t('faq_johnny:question7'),
			answer: `<div>${t('faq_johnny:answer7_text1')}</div>
      <ul>
      <li>${t('faq_johnny:answer7_text2')}</li>
      <li>${t('faq_johnny:answer7_text3')}</li>
      <li>${t('faq_johnny:answer7_text4')}</li>
      <li>${t('faq_johnny:answer7_text5')}</li>
      <li>${t('faq_johnny:answer7_text6')}</li>
      </ul>
      <p>${t('faq_johnny:answer7_text7')}</p>`,
			anchor: 'question7'
		},
		{
			id: 8,
			question: t('faq_johnny:question8'),
			answer: `<div>${t('faq_johnny:answer8_text1')}</div>
      <ul>
      <li>${t('faq_johnny:answer8_text2')}</li>
      <li>${t('faq_johnny:answer8_text3')}</li>
      <li>${t('faq_johnny:answer8_text4')}</li>
      </ul>
      <p>${t('faq_johnny:answer8_text5')}</p>`,
			anchor: 'question8'
		},
		{
			id: 9,
			question: t('faq_johnny:question9'),
			answer: `<div>${t('faq_johnny:answer9_text1')}</div>`,
			anchor: 'question9'
		}
	],
	com2: [
		{
			id: 999,
			question: t('faq_vippass:questionMoney'),
			answer: `<div>${t('faq_vippass:answerQuestionMoney')}</div>`,
			anchor: 'vip_pass_money'
		},
		{
			id: 1,
			question: t('faq_vippass:question1'),
			answer: `<div>${t('faq_vippass:answer1_text1')}</div>`,
			anchor: 'question1'
		},
		{
			id: 2,
			question: t('faq_vippass:question2'),
			answer: `<div>${t('faq_vippass:answer2')}</div>`,
			anchor: 'question2'
		},
		{
			id: 3,
			question: t('faq_vippass:question3'),
			answer: `<div>${t('faq_vippass:answer3_text1')}</div>
      <div>${t('faq_vippass:answer3_text2')}</div>
      <ul>
      <li>${t('faq_vippass:answer3_text3')}</li>
      <li>${t('faq_vippass:answer3_text4')}</li>
      <li>${t('faq_vippass:answer3_text5')}</li>
      <li>${t('faq_vippass:answer3_text8')}</li>
      <li>${t('faq_vippass:answer3_text9')}</li>
      </ul>`,
			anchor: 'question3'
		},
		{
			id: 4,
			question: t('faq_vippass:question4'),
			answer: `<div>${t('faq_vippass:answer4_text1')}</div>`,
			anchor: 'question4'
		},
		{
			id: 5,
			question: t('faq_vippass:question5'),
			answer: `<div>${t('faq_vippass:answer5')}</div>`,
			anchor: 'question5'
		},
		{
			id: 6,
			question: t('faq_vippass:question6'),
			answer: `<div>${t('faq_vippass:answer6_text1')}</div>`,
			anchor: 'question6'
		},
		{
			id: 7,
			question: t('faq_vippass:question7'),
			answer: `<div>${t('faq_vippass:answer7_text1')}</div>
      <ul>
      <li>${t('faq_vippass:answer7_text2')}</li>
      <li>${t('faq_vippass:answer7_text3')}</li>
      <li>${t('faq_vippass:answer7_text4')}</li>
      <li>${t('faq_vippass:answer7_text5')}</li>
      <li>${t('faq_vippass:answer7_text6')}</li>
      </ul>
      <p>${t('faq_vippass:answer7_text7')}</p>`,
			anchor: 'question7'
		},
		{
			id: 8,
			question: t('faq_vippass:question8'),
			answer: `<div>${t('faq_vippass:answer8_text1')}</div>
      <ul>
      <li>${t('faq_vippass:answer8_text2')}</li>
      <li>${t('faq_vippass:answer8_text3')}</li>
      <li>${t('faq_vippass:answer8_text4')}</li>
      </ul>
      <p>${t('faq_vippass:answer8_text5')}</p>`,
			anchor: 'question8'
		},
		{
			id: 9,
			question: t('faq_vippass:question9'),
			answer: `<div>${t('faq_vippass:answer9_text1')}</div>`,
			anchor: 'question9'
		},
		{
			id: 10,
			question: t('faq_vippass:question10'),
			answer: `<div>${t('faq_vippass:answer10_text1')}</div>`,
			anchor: 'question10'
		}
	]
});
